import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { DrcordinatorTokenService } from './drcordinator-token.service';

@Injectable({
  providedIn: 'root',
})

export class DrcordinatorAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: DrcordinatorTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}